// One retry loop per shared resource, regardless of how many components read it.
// Only mounted readers keep it alive; focus/online can accelerate recovery but
// cannot turn repeated browser events into an unbounded request burst.
export function createRecoveryRetry(retry) {
    let readers = 0;
    let failed = false;
    let timer = null;
    let lastFailureAt = 0;

    function cancel() {
        if (timer !== null) clearTimeout(timer);
        timer = null;
    }

    function schedule(delay = 30_000) {
        if (!readers || !failed || timer !== null) return;
        timer = setTimeout(() => {
            timer = null;
            failed = false;
            retry();
        }, delay);
    }

    function wake() {
        if (!failed) return;
        cancel();
        schedule(Math.max(0, 1_000 - (Date.now() - lastFailureAt)));
    }

    return {
        subscribe() {
            readers += 1;
            if (readers === 1 && typeof window !== "undefined") {
                window.addEventListener?.("online", wake);
                window.addEventListener?.("focus", wake);
            }
            schedule();
            return () => {
                readers -= 1;
                if (readers) return;
                cancel();
                if (typeof window !== "undefined") {
                    window.removeEventListener?.("online", wake);
                    window.removeEventListener?.("focus", wake);
                }
            };
        },
        failure() {
            failed = true;
            lastFailureAt = Date.now();
            schedule();
        },
        reset() {
            failed = false;
            cancel();
        },
    };
}
